import { Variant } from './types';

export const tabId = (prefix: string, index: number) => `${prefix}:tab-${index}`;
export const tabPanelId = (prefix: string, index: number) => `${prefix}:tabpanel-${index}`;
export const getIndexFromTabId = (tabId = '') => parseInt(tabId.split(':tab-').pop() || '0', 10);
export const isSegmentedControlVariant = (variant: Variant) =>
    variant === 'segmentedControl' || variant === 'segmentedControlRounded';
